(function () {

    angular
        .module('app')
        .controller('ClassroomJoinController', ClassroomJoinController)
        .directive('classroomFileInput', classroomFileInput);

    ClassroomJoinController.$inject = [
        'authService',
        'classroomService',
        'loggerService',
        '$q',
        '$window'
    ];

    function classroomFileInput() {
        return {
            restrict : 'A',
            scope : {
                classroomFileInput : '='
            },
            link : function (scope, element) {
                element.on('change', function (event) {
                    scope.$apply(function () {
                        scope.classroomFileInput = event.target.files && event.target.files.length ?
                            event.target.files[0] :
                            null;
                    });
                });
            }
        };
    }

    function ClassroomJoinController(authService, classroomService, loggerService, $q, $window) {
        var vm = this;
        var maxArtifactSize = 20 * 1024 * 1024;

        vm.authService = authService;
        vm.busy = false;
        vm.submitting = false;
        vm.error = '';
        vm.notice = '';
        vm.joinCode = '';
        vm.joinedSession = null;
        vm.joinedAt = null;
        vm.assignments = [];
        vm.allocations = [];
        vm.usageLedger = [];
        vm.usageBusy = false;
        vm.usageForm = {
            abilityId : '',
            amount : 100,
            reason : '课堂 AI 创作',
            prompt : ''
        };
        vm.aiOutput = '';
        vm.aiNotice = '';
        vm.aiError = '';
        vm.submissions = [];
        vm.submissionsBusy = false;
        vm.submissionTitle = '';
        vm.submissionStorage = 'cloud';
        vm.selectedAssignmentId = '';
        vm.selectedFile = null;
        vm.fileNotice = '';
        vm.submissionNotice = '';
        vm.submissionError = '';
        vm.isAuthenticated = authService.isAuthenticated();

        function getJoinedClassroomStorageKey() {
            var userid = vm.profile && (vm.profile.user_id || vm.profile.id || vm.profile.tenant);
            return 'qitan:last-classroom:' + (userid || 'anonymous');
        }

        function saveJoinedClassroom(session, joinedAt) {
            if (!$window.localStorage || !session || !session.id || !session.classid) {
                return;
            }

            try {
                $window.localStorage.setItem(getJoinedClassroomStorageKey(), JSON.stringify({
                    session : session,
                    joinedAt : joinedAt || new Date().toISOString()
                }));
            }
            catch (err) {
                loggerService.error('[classroom-join] save joined classroom failed', err);
            }
        }

        function clearJoinedClassroom() {
            if (!$window.localStorage) {
                return;
            }

            try {
                $window.localStorage.removeItem(getJoinedClassroomStorageKey());
            }
            catch (err) {
                loggerService.error('[classroom-join] clear joined classroom failed', err);
            }
        }

        function restoreJoinedClassroom() {
            if (!$window.localStorage || !vm.profile || vm.profile.role === 'supervisor') {
                return;
            }

            var stored;
            try {
                stored = JSON.parse($window.localStorage.getItem(getJoinedClassroomStorageKey()) || 'null');
            }
            catch (err) {
                loggerService.error('[classroom-join] restore joined classroom failed', err);
                clearJoinedClassroom();
                return;
            }

            if (!stored || !stored.session || !stored.session.id || !stored.session.classid) {
                return;
            }

            vm.joinedSession = stored.session;
            vm.joinedAt = stored.joinedAt ? new Date(stored.joinedAt) : null;
            vm.busy = true;
            $q.all([
                loadAssignments(stored.session),
                loadAllocations(stored.session),
                loadUsage(stored.session),
                loadSubmissions(stored.session)
            ])
                .then(function () {
                    vm.notice = '已恢复最近加入的课堂。';
                })
                .catch(function (err) {
                    loggerService.error('[classroom-join] restore classroom data failed', err);
                    clearJoinedClassroom();
                    vm.joinedSession = null;
                    vm.error = '最近加入的课堂已不可用，请重新输入课堂码。';
                })
                .finally(function () {
                    vm.busy = false;
                });
        }

        authService.getProfileDeferred()
            .then(function (profile) {
                vm.profile = profile;
                vm.isAuthenticated = true;
                restoreJoinedClassroom();
            })
            .catch(function () {
                vm.isAuthenticated = authService.isAuthenticated();
            });

        function loadAssignments(session) {
            return classroomService.getAssignments(vm.profile, session.classid, session.id)
                .then(function (assignments) {
                    vm.assignments = assignments || [];
                    if (!vm.selectedAssignmentId && vm.assignments.length) {
                        vm.selectedAssignmentId = vm.assignments[0].id;
                    }
                });
        }

        function loadAllocations(session) {
            return classroomService.getAllocations(vm.profile, session.classid)
                .then(function (result) {
                    vm.allocations = result.allocations || [];
                    if (!vm.usageForm.abilityId && vm.allocations.length) {
                        vm.usageForm.abilityId = vm.allocations[0].abilityId;
                    }
                })
                .catch(function (err) {
                    loggerService.error('[classroom-join] load allocations failed', err);
                    vm.allocations = [];
                });
        }

        function loadUsage(session) {
            return classroomService.getUsage(vm.profile, session.classid)
                .then(function (usageLedger) {
                    vm.usageLedger = usageLedger || [];
                })
                .catch(function (err) {
                    loggerService.error('[classroom-join] load usage failed', err);
                    vm.usageLedger = [];
                });
        }

        function loadSubmissions(session) {
            return classroomService.getSubmissions(vm.profile, session.classid, session.id)
                .then(function (submissions) {
                    vm.submissions = submissions || [];
                })
                .catch(function (err) {
                    loggerService.error('[classroom-join] load submissions failed', err);
                    vm.submissions = [];
                });
        }

        vm.getSessionStatusLabel = function (status) {
            var labels = {
                open : '进行中',
                draft : '准备中',
                closed : '已结束'
            };
            return labels[status] || status || '未知';
        };

        vm.getContentPackTitle = function (packid) {
            var labels = {
                'scratch-demo' : 'Scratch AI 互动模板',
                'media-prompt' : 'AI 多媒体提示词卡',
                'python-agent' : 'AI 编程任务模板',
                'hardware-lab' : '智能硬件实验记录表'
            };
            return labels[packid] || packid;
        };

        vm.getAssignmentTitle = function (assignmentId) {
            if (!assignmentId) {
                return '未关联课堂任务';
            }
            var match = vm.assignments.filter(function (assignment) {
                return assignment.id === assignmentId;
            })[0];
            return match ? match.title : '已下发任务';
        };

        vm.getAbilityName = function (abilityId) {
            var labels = {
                text : '文本问答',
                image : 'AI 生图',
                vision : '图片理解',
                tts : '语音合成',
                '3d' : '3D 建模',
                robotics : '具身智能'
            };
            return labels[abilityId] || abilityId;
        };

        vm.getUnitLabel = function (unit) {
            var labels = {
                tokens : '令牌',
                credits : '点数',
                characters : '字符'
            };
            return labels[unit] || unit || '';
        };

        vm.getSubmissionStatusLabel = function (status) {
            var labels = {
                submitted : '已提交',
                reviewed : '已批阅',
                returned : '已退回'
            };
            return labels[status] || status || '已提交';
        };

        vm.getStorageLabel = function (storage) {
            var labels = {
                cloud : '云端作品库',
                'object-store' : '开源对象存储',
                'database-fallback' : '课堂本地兜底',
                'teacher-browser' : '教师本地浏览器',
                'student-export' : '学生导出作品包'
            };
            return labels[storage] || storage || '未设置';
        };

        vm.getLearningStepState = function (step) {
            if (step === 'join') {
                return vm.joinedSession ? '已完成' : '进行中';
            }
            if (step === 'task') {
                return vm.assignments.length ? '已收到' : '等待中';
            }
            if (step === 'work') {
                return vm.submissions.length ? '已提交' : '准备中';
            }
            return '下一步';
        };

        function getFriendlyError(err, fallback) {
            var message = err && err.data && (err.data.error || err.data.message);
            var known = {
                'Missing classroom join code' : '请输入老师提供的课堂码。',
                'Classroom join code not found' : '没有找到这个课堂码，请确认后再试。',
                'Only students can join a classroom' : '只有学生账号可以加入课堂。',
                'Classroom code is for a different class' : '这个课堂码不属于当前班级。',
                'Missing submission title' : '请输入作品名称。',
                'Submission attachment is too large' : '附件太大，请压缩后再提交。',
                'Invalid submission attachment' : '附件格式读取失败，请重新选择文件。',
                'AI quota is not enough' : '可用额度不足，请联系老师重新分配。',
                'Missing AI usage target' : '请选择要使用的 AI 能力。',
                'AI usage amount must be greater than zero' : '使用额度必须大于 0。',
                '请选择要使用的 AI 能力' : '请选择要使用的 AI 能力。',
                '使用额度必须大于 0' : '使用额度必须大于 0。',
                '请输入这次要交给 AI 处理的任务说明' : '请输入这次要交给 AI 处理的任务说明。',
                '可用额度不足，请联系老师重新分配' : '可用额度不足，请联系老师重新分配。',
                '老师还没有为你分配这个 AI 能力' : '老师还没有为你分配这个 AI 能力，请先联系老师分配额度。',
                '请输入作品名称' : '请输入作品名称。',
                'Open-source object storage is not configured for larger classroom attachments' :
                    '大附件需要先配置开源对象存储。请联系老师或管理员。'
            };
            return known[message] || message || (err && err.message) || fallback;
        }

        vm.joinClassroom = function () {
            vm.error = '';
            vm.notice = '';
            vm.aiNotice = '';
            vm.aiError = '';
            vm.submissionNotice = '';
            vm.submissionError = '';

            if (!vm.joinCode || vm.joinCode.trim().length === 0) {
                vm.error = '请输入老师提供的课堂码。';
                return;
            }

            vm.busy = true;
            classroomService.joinClassroom(vm.joinCode.trim().toUpperCase())
                .then(function (result) {
                    vm.joinedSession = result.session;
                    vm.joinedAt = result.joinedAt ? new Date(result.joinedAt) : new Date();
                    saveJoinedClassroom(result.session, vm.joinedAt.toISOString());
                    vm.notice = '已加入课堂，可以查看任务并提交作品。';
                    return $q.all([
                        loadAssignments(result.session),
                        loadAllocations(result.session),
                        loadUsage(result.session),
                        loadSubmissions(result.session)
                    ]);
                })
                .catch(function (err) {
                    loggerService.error('[classroom-join] failed', err);
                    vm.error = getFriendlyError(err, '加入课堂失败，请检查课堂码是否正确。');
                })
                .finally(function () {
                    vm.busy = false;
                });
        };

        vm.refreshAssignments = function () {
            if (!vm.joinedSession) {
                return;
            }
            loadAssignments(vm.joinedSession)
                .then(function () {
                    vm.notice = '已刷新课堂任务。';
                })
                .catch(function (err) {
                    loggerService.error('[classroom-join] refresh assignments failed', err);
                    vm.error = '刷新课堂任务失败。';
                });
        };

        vm.refreshAllocations = function () {
            if (!vm.joinedSession) {
                return;
            }
            loadAllocations(vm.joinedSession)
                .then(function () {
                    vm.notice = '已刷新我的额度。';
                });
        };

        vm.refreshUsage = function () {
            if (!vm.joinedSession) {
                return;
            }
            vm.usageBusy = true;
            loadUsage(vm.joinedSession)
                .then(function () {
                    vm.notice = '已刷新 AI 使用流水。';
                })
                .finally(function () {
                    vm.usageBusy = false;
                });
        };

        vm.invokeCapability = function () {
            if (!vm.joinedSession) {
                vm.aiError = '请先加入课堂。';
                return;
            }
            if (!vm.usageForm.abilityId) {
                vm.aiError = '请选择要使用的 AI 能力。';
                return;
            }
            if (!vm.usageForm.amount || Number(vm.usageForm.amount) <= 0) {
                vm.aiError = '使用额度必须大于 0。';
                return;
            }
            if (!vm.usageForm.prompt || vm.usageForm.prompt.trim().length === 0) {
                vm.aiError = '请输入这次要交给 AI 处理的任务说明。';
                return;
            }

            vm.usageBusy = true;
            vm.aiNotice = '';
            vm.aiError = '';
            vm.aiOutput = '';
            classroomService.invokeAiCapability(vm.profile, vm.joinedSession.classid, {
                abilityId : vm.usageForm.abilityId,
                amount : Number(vm.usageForm.amount),
                reason : vm.usageForm.reason,
                prompt : vm.usageForm.prompt
            })
                .then(function (result) {
                    vm.aiOutput = result.output || '';
                    vm.aiNotice = vm.aiOutput ?
                        'AI 已完成回复，剩余额度和使用流水已更新。' :
                        'AI 调用已完成，剩余额度和使用流水已更新。';
                    return $q.all([
                        loadAllocations(vm.joinedSession),
                        loadUsage(vm.joinedSession)
                    ]);
                })
                .catch(function (err) {
                    loggerService.error('[classroom-join] invoke AI capability failed', err);
                    vm.aiError = getFriendlyError(err, 'AI 调用失败，请稍后再试。');
                })
                .finally(function () {
                    vm.usageBusy = false;
                });
        };

        vm.refreshSubmissions = function () {
            if (!vm.joinedSession) {
                return;
            }
            vm.submissionsBusy = true;
            loadSubmissions(vm.joinedSession)
                .then(function () {
                    vm.submissionNotice = '已刷新我的提交记录。';
                })
                .finally(function () {
                    vm.submissionsBusy = false;
                });
        };

        function readSelectedFile() {
            var deferred = $q.defer();

            if (!vm.selectedFile) {
                deferred.resolve(null);
                return deferred.promise;
            }

            if (vm.selectedFile.size > maxArtifactSize) {
                deferred.reject(new Error('附件不能超过 20MB。'));
                return deferred.promise;
            }

            var reader = new FileReader();
            reader.onload = function () {
                deferred.resolve({
                    artifactName : vm.selectedFile.name,
                    artifactType : vm.selectedFile.type || 'application/octet-stream',
                    artifactSize : vm.selectedFile.size,
                    artifactData : reader.result
                });
            };
            reader.onerror = function () {
                deferred.reject(new Error('读取附件失败。'));
            };
            reader.readAsDataURL(vm.selectedFile);

            return deferred.promise;
        }

        vm.submitWork = function () {
            vm.submissionNotice = '';
            vm.submissionError = '';

            if (!vm.joinedSession) {
                vm.submissionError = '请先加入课堂。';
                return;
            }
            if (!vm.submissionTitle || vm.submissionTitle.trim().length === 0) {
                vm.submissionError = '请输入作品名称。';
                return;
            }

            vm.submitting = true;
            readSelectedFile()
                .then(function (artifact) {
                    var submission = {
                        title : vm.submissionTitle.trim(),
                        storage : vm.submissionStorage,
                        assignmentId : vm.selectedAssignmentId || undefined
                    };
                    if (artifact) {
                        submission.artifactName = artifact.artifactName;
                        submission.artifactType = artifact.artifactType;
                        submission.artifactSize = artifact.artifactSize;
                        submission.artifactData = artifact.artifactData;
                    }
                    return classroomService.createSubmission(vm.profile, vm.joinedSession.classid, vm.joinedSession.id, submission);
                })
                .then(function () {
                    vm.submissionTitle = '';
                    vm.selectedFile = null;
                    vm.fileNotice = '';
                    vm.submissionNotice = '作品已提交给老师。';
                    return loadSubmissions(vm.joinedSession);
                }).catch(function (err) {
                loggerService.error('[classroom-join] submit work failed', err);
                vm.submissionError = getFriendlyError(err, '作品提交失败，请稍后再试。');
            }).finally(function () {
                vm.submitting = false;
            });
        };
    }
}());
